"use client";

import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useState } from "react";
const teamMembers = [{
  id: 1,
  name: "Emma Chen",
  role: "Coffee Curator",
  bio: "With 10+ years in specialty coffee, Emma sources the finest roasters across Canada.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1458826/img/emma_chen_portrait.png"
}, {
  id: 2,
  name: "Marcus Roy",
  role: "Content Writer",
  bio: "Marcus crafts engaging stories about coffee culture and roasting artistry.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1458826/img/marcus_roy_portrait.png"
}, {
  id: 3,
  name: "Sophia Tan",
  role: "Review Analyst",
  bio: "Sophia analyzes Google and Yotpo ratings to ensure our list stays accurate.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1458826/img/sophia_tan_portrait.png"
}];
export default function MeetTheTeam() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  const [hoveredId, setHoveredId] = useState<number | null>(null);
  return <section ref={ref} className="relative bg-dark-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <h2 className="font-display text-foreground-dark text-center text-3xl sm:text-4xl lg:text-5xl font-bold mb-12">
          Meet the Team
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
          {teamMembers.map((member, i) => <Card key={member.id} data-index={i} onMouseEnter={() => setHoveredId(member.id)} onMouseLeave={() => setHoveredId(null)} className={`
                relative overflow-hidden bg-background border-2 border-primary/30
                shadow-[0_0_16px_rgba(157,110,56,0.2)]
                transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]
                ${hoveredId === member.id ? "translate-y-[-4px] shadow-[0_8px_24px_rgba(157,110,56,0.35)]" : ""}
                ${isVisible ? "animate-fade-in-up" : "opacity-0"}
              `} style={{
          animationDelay: isVisible ? `${i * 200}ms` : "0ms"
        }}>
              <div className="relative aspect-[3/4] overflow-hidden bg-muted">
                <img src={member.image} alt={member.name} className={`
                    w-full h-full object-cover
                    transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)]
                    ${hoveredId === member.id ? "scale-[1.03]" : "scale-100"}
                  `} />
              </div>

              <CardContent className="relative pt-6 pb-6 px-6">
                <div className={`
                    transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]
                    ${hoveredId === member.id ? "translate-y-[-8px]" : "translate-y-0"}
                  `}>
                  <h3 className="font-display text-foreground text-xl font-bold mb-1">
                    {member.name}
                  </h3>
                  <p className="text-primary text-sm font-semibold mb-3">
                    {member.role}
                  </p>
                </div>

                <div className={`
                    overflow-hidden transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]
                    ${hoveredId === member.id ? "max-h-32 opacity-100" : "max-h-0 opacity-0"}
                  `}>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    {member.bio}
                  </p>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}